
/**
 * 百度地图 移动web页面导航
 * @param start  {lnglat:[lng, lat], city: string, name:string}  起始点
 * @param target [lnglat:[lng, lat], city: string, name:string]  终点
 */
 export function baiduNavigate(start, target, coordinate) {
    if (target.lnglat.filter(res => !isNaN(res) && res !== '').length !== 2) {
      alert('经纬度错误')
      return
    }
    const uri = 'api.map.baidu.com/direction'
    const params = {
      origin: `name:${start.name || '起点'}|latlng:${start.lnglat.reverse().join(',')}`,
      destination: `name:${target.name || '终点'}|latlng:${target.lnglat.reverse().join(',')}`,
      mode: 'driving',
      output: 'html',
      'origin_region': start.city,
      'destination_region': target.city,
      coord_type: coordinate || 'wgs84',
      src: 'webapp.jczy.qiyu'
    }
  
    const queryString = queryStringFromParams(params)
    const url = `http://${uri}?${queryString}`
    // location.href = url
    window.open(url)
  }
  function queryStringFromParams(params) {
    const arr = []
    for (const k in params) {
      const val = encodeURIComponent(params[k])
      arr.push(`${k}=${val}`)
    }
    return arr.join('&')
  }
 
  